
import { Component, Injector, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { BaseResourceFormComponent, EddyAutoComplete, FuncaoService, GlobalService, LoginContabil, Aviso, DateFormatPipe, SetorService, Setor, AvisoSetor, AvisoStorage } from 'eddydata-lib';
import { ConfirmationService, MessageService } from 'primeng/api';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { AvisoService } from '../service/aviso.service';
import { warning } from 'toastr';
import { AvisoSetorService } from '../service/aviso-setor.service';
import { AvisoStorageService } from '../service/aviso-storage.service';

declare var $: any;

@Component({
  selector: 'lib-aviso-form',
  templateUrl: './aviso-form.component.html',
  styleUrls: ['./aviso-form.component.css'],
})
export class AvisoFormComponent extends BaseResourceFormComponent<Aviso, LoginContabil> implements OnInit {

  // ========================================================================
  // ----------------------- DECLARAÇÃO DE VARIAVEIS ------------------------
  // ========================================================================
  public setorAutoComplete: EddyAutoComplete<any>;
  public setorAtual: Setor;
  public listaArquivos: AvisoStorage[] = [];

  // ========================================================================
  // ------------------------------ CONSTRUTOR ------------------------------
  // ========================================================================
  constructor(
    protected injector: Injector,
    private messageService: MessageService,
    protected globalService: GlobalService,
    protected funcaoService: FuncaoService,
    protected confirmationService: ConfirmationService,
    protected avisoService: AvisoService,
    protected avisoSetorService: AvisoSetorService,
    protected avisoStorageService: AvisoStorageService,
    protected setorService: SetorService) {
    super(new Aviso(), injector, Aviso.converteJson, avisoService);
  }

  // ========================================================================
  // -------------------------- MÉTODOS ABSTRAÍDOS --------------------------
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      data_inicio: [null, [Validators.required]],
      data_fim: [null, [Validators.required]],
      mensagem: [null, [Validators.required]],
      orgao: [this.login.orgao, [Validators.required]],
      emissor: [this.login.usuario, [Validators.required]],
      setores: [null],
    });
  }

  protected parametrosExtras(): {} {
    ''
    return {
      relations: 'orgao,setores.setor,storages'
    };
  }

  protected async podeAlterar(entidade: Aviso): Promise<boolean> {
    return true;
  }

  protected async afterLoad() {
    this.entidade.data_inicio = new DateFormatPipe().transform(this.entidade.data_inicio, []);
    this.entidade.data_fim = new DateFormatPipe().transform(this.entidade.data_fim, []);
    this.carregarAutoCompletes();
    this.avisoStorageService.filtrar(0, -1, { 'aviso.id': this.entidade.id }).pipe(takeUntil(this.unsubscribe)).subscribe((data: any) => {
      this.listaArquivos = data ? data.content : new Array<AvisoStorage>();
    });
  }

  protected afterInit(): void {
    this.carregarAutoCompletes()
  }

  protected beforeSubmit() {
    try {
      if (!this.entidadeForm.get('data_inicio').value) {
        throw new Error('Informe a Data de Início!');
      }
      if (!this.entidadeForm.get('data_fim').value) {
        throw new Error('Informe a Data de Fim!');
      }

      if (this.entidadeForm.get('data_inicio').value > this.entidadeForm.get('data_fim').value) {
        throw new Error('A data de início deve ser menor que a data de fim');
      }
      if (!this.entidadeForm.get('mensagem').value) {
        throw new Error('Informe a Mensagem!');
      }
      this.entidadeForm.get('setores').setValue(this.entidade.setores);

      if (!this.entidade.setores || this.entidade.setores.length == 0) {
        throw new Error('Informe pelo menos um setor para receber o aviso!');
      }
    } catch (e) {
      this.funcaoService.acaoErro(e);
      throw e;
    }
  }

  protected afterSubmit(ent: Aviso) {
    this.mensagemSucesso = 'Registro salvo com sucesso!';
    if (this.currentActionRoute == 'novo') {
      this.router.navigate(['/avisos', ent.id, 'editar']);
    }
  }

  // ========================================================================
  // -------------------------- MÉTODOS DA CLASSE ---------------------------
  // ========================================================================

  private carregarAutoCompletes() {
    this.setorAutoComplete = new EddyAutoComplete(
      this.entidadeForm.get('setores'),
      this.setorService,
      'id',
      ['codigo', 'nome'],
      { orgao_id: this.login.orgao.id, ativo: true },
      { text: ['codigo', 'nome'] }
    );
  }


  public adicionarUsuarioSetor() {
    if (!this.setorAtual) return;
    if (!this.entidade.setores) this.entidade.setores = [];
    if (this.entidade.setores.find(m => m.setor?.id === this.setorAtual.id)) {
      warning(`Setor ${this.setorAtual.nome} já vinculado!`);
    } else {
      this.entidade.setores.push({ setor: this.setorAtual } as AvisoSetor);
    }

    this.setorAtual = undefined
  }

  public removerUsuarioSetor(item: AvisoSetor, index: number) {
    if (!item) return
    this.entidade.setores.splice(index, 1);
    if (item?.id) {
      this.avisoSetorService.remover(item.id).pipe(takeUntil(this.unsubscribe))
        .subscribe(res => { toastr.success('Removido com sucesso!') },
          err => { this.funcaoService.acaoErro(err); },
        )
    }
  }
};